import { render } from "./LeadsConvertToProjectDialog.vue?vue&type=template&id=018c81b0"
import script from "./LeadsConvertToProjectDialog.vue?vue&type=script&lang=js"
export * from "./LeadsConvertToProjectDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__